import { useEffect, useState } from "react";

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// useDebouncedValue — returns `value` delayed by `delayMs`, resetting the timer
// on every change. Used by Compass quick search so the input stays instantly
// responsive while the (potentially expensive, per-keystroke) query only fires
// ~300ms after the user stops typing.
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
export function useDebouncedValue(value, delayMs = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return debounced;
}

export default useDebouncedValue;
